import { Box, Grid, GridItem, Text } from "@chakra-ui/react"
import React from "react"
import { Colors } from "../../theme/colors"

export const MS70CDocumentation: React.FC = (): JSX.Element => {
  const headerStyles = {
    fontWeight: "bold",
    bg: Colors.Primary.accent,
    px: "4px",
    py: "2",
    fontSize: "14px",
    color: "white",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const columnStyles = {
    px: "4px",
    py: "2",
    bg: "white",
    fontSize: "14px",
    textAlign: "left" as const
  }
  const frlStyle = {
    py: "2",
    bg: "white",
    fontSize: "14px",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const firstColumnStyles = {
    py: "2",
    bg: "white",
    fontSize: "14px",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const tableHeadingStyles = {
    mt: "6",
    fontWeight: "bold",
    fontSize: "18px",
    color: Colors.Primary.c1
  }

  return (
    <Box>
      <Text {...tableHeadingStyles}>Cable and Conduit Details – Separation Active Area to Active Area</Text>

      {/* Main Table: Cable and Conduit Details */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="2fr 3fr 1fr 1fr 1fr 1fr" bg="gray.200" gap="1px">
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Detail
          </GridItem>
          <GridItem {...headerStyles} colSpan={4}>
            FRL
          </GridItem>

          {/* FRL Sub-headers */}
          <GridItem {...headerStyles} colSpan={2}>
            80mm collar separation
          </GridItem>
          <GridItem {...headerStyles} colSpan={2}>
            40mm collar separation
          </GridItem>

          {/* FRL Sub-sub-headers */}
          <Box {...headerStyles}>≥150mm slab</Box>
          <Box {...headerStyles}>≥175mm slab</Box>
          <Box {...headerStyles}>≥150mm slab</Box>
          <Box {...headerStyles}>≥175mm slab</Box>

          {/* Row 1: Mix services */}
          <Box {...firstColumnStyles}>
            <Text fontWeight="bold">Mix services</Text>
          </Box>
          <Box {...columnStyles}>
            Various cable combinations from above with or without conduit in the collar. <br />
            Only one conduit allowed in the collar. (Refer to line 1 for conduit details).
          </Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 2: One PVC Conduit */}
          <Box {...firstColumnStyles}>
            <Text fontWeight="bold">
              One PVC Conduit
              <br />
              (20mm – 50mm nominal)
            </Text>
          </Box>
          <Box {...columnStyles}>One empty rigid PVC conduit of (1.6mm to 3mm wall thickness). Minimum 100mm protruding above and below slab.</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 3: Data and Comms Cables (Cat5, Cat5e) */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Data and Comms Cables </b>
              <br />
              (Cat5, Cat5e)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to 100 Cables <br />
            With or without PVC conduit in the collar. (Refer to line 1 for conduit details)
          </Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 4: Data & Comms Cables (Cat6, Cat6a, Cat7, RG6) */}
          <Box {...firstColumnStyles}>
            <Text>
              <b>Data & Comms Cables</b> <br />
              (Cat6, Cat6a, Cat7, RG6)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to 80 Cables <br />
            With or without PVC conduit in the collar. (Refer to line 1 for conduit details)
          </Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 5: Fibre optic cables (10.3mm diameter) */}
          <Box {...firstColumnStyles}>
            <Text fontWeight="bold">
              Fibre optic cables <br />
              (10.3mm diameter)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to full Cables
            <br /> With or without PVC conduit in the collar. (Refer to line 1 for conduit details)
          </Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 6: Fibre optic cables (5.3mm diameter) */}
          <Box {...firstColumnStyles}>
            <Text fontWeight="bold">
              Fibre optic cables <br />
              (5.3mm diameter)
            </Text>
          </Box>
          <Box {...columnStyles}>
            1 to 10 Cables <br />
            With or without PVC conduit in the collar. (Refer to line 1 for conduit details)
          </Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 7: Round insulated copper cables (2.5mm² to 16mm² 3C+E) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Round insulated copper cables </b>
              (2.5mm² to 16mm² 3C+E)
            </Text>
          </GridItem>
          <GridItem {...columnStyles}>
            1 to full in collar or in conduit With PVC conduit in the collar. (Refer to line 1 for conduit details)
          </GridItem>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/180</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 8: Round insulated copper cables (2.5mm² to 16mm² 3C+E) - Without PVC conduit */}
          <GridItem {...columnStyles}>
            1 to full in collar or in conduit Without PVC conduit in the collar. (Refer to line 1 for conduit details)
          </GridItem>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 9: Flat TPS copper cables (2.5mm² 2C+E) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Flat TPS copper cables</b> <br />
              (2.5mm² 2C+E)
            </Text>
          </GridItem>
          <GridItem {...columnStyles}>1 to 60 Cables With PVC conduit in the collar. (Refer to line 1 for conduit details)</GridItem>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 10: Flat TPS copper cables (2.5mm² 2C+E) - Without PVC conduit */}
          <GridItem {...columnStyles}>1 to 60 Cables Without PVC conduit in the collar. (Refer to line 1 for conduit details)</GridItem>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/180</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Row 11: Sealant details */}
          <GridItem {...firstColumnStyles}>
            <Text fontWeight="bold" mb="2" color={Colors.Primary.c1}>
              Sealant details
            </Text>
          </GridItem>
          <GridItem {...columnStyles} colSpan={5}>
            <Text>
              In the annular gap between collar opening and cable services or gaps between services not bundled.
              <br />
              <Text as="span" fontWeight="bold">
                When gap ≤5mm:
              </Text>{" "}
              sealant is optional.
              <br />
              <Text as="span" fontWeight="bold">
                When gap ≥ 6mm:
              </Text>
              <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px", color: Colors.Primary.c1 }}>
                Snap Fire Seal FRAS
              </a>{" "}
              to fill gaps to a minimum depth of 10mm depth and finished off flush with the collar opening.
              <br />
              There is no requirement to seal between the conduit and the services passing through the conduit.
            </Text>
          </GridItem>
        </Grid>
      </Box>

      {/* Lagged Pipe Details 80mm Collar Separation Table */}
      <Text {...tableHeadingStyles} mt="8">
        Lagged Pipe Details – 80mm Collar Separation – Active Area to Active Area
      </Text>
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="4fr 1fr repeat(7, 1fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Slab Thickness
          </GridItem>
          <GridItem {...headerStyles} colSpan={7}>
            FRL for each lagging type
          </GridItem>

          {/* Sub-headers under FRL */}
          <Box {...headerStyles}>PE Foam</Box>
          <Box {...headerStyles}>Thermotec E-Flex ST</Box>
          <Box {...headerStyles}>K-Flex ST</Box>
          <Box {...headerStyles}>SuperMax</Box>
          <Box {...headerStyles}>Armaflex FRV nitrile rubber</Box>
          <Box {...headerStyles}>Actrol SuperPair F/R</Box>
          <Box {...headerStyles}>Foilflex / Sekisui foam Foil-faced</Box>

          {/* Sub-sub-headers */}
          <Box {...headerStyles}>9mm lagging</Box>
          <Box {...headerStyles}>9mm lagging</Box>
          <Box {...headerStyles}>9-19mm lagging</Box>
          <Box {...headerStyles}>9-19mm lagging</Box>
          <Box {...headerStyles}>9-19mm lagging</Box>
          <Box {...headerStyles}>9-19mm lagging</Box>
          <Box {...headerStyles}>25mm lagging</Box>

          {/* Paircoil Bundle A - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Paircoil Bundle A</b> <br />
              One set of Paircoil (max 3/8" & 3/4") with or without any of the following services:
              <br />
              <ul style={{ listStyleType: "disc", paddingLeft: "20px", textAlign: "left" }}>
                <li>One of up to 25mm PVC pipe</li>
                <li>One of up to 2.5mm² 2C+E TPS power cable</li>
                <li>One of either CAT 5, 5e, 6, 6a or 7 cable</li>
              </ul>
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>-/180/90</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Paircoil Bundle A - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>-/240/90</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/180</Box>
          <Box {...frlStyle}>-/240/180</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Paircoil Bundle B - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Paircoil Bundle B </b>
              <br />
              One or two sets of Paircoil (max 3/4" & 3/4") with or without any of the following services:
              <br />
              <ul style={{ listStyleType: "disc", paddingLeft: "20px", textAlign: "left" }}>
                <li>One of up to 2.5-mm² 2C+E TPS power cables</li>
                <li>One or two of CAT 5, 5e, 6, 6a or 7 cable</li>
              </ul>
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>N/A</Box>

          {/* Paircoil Bundle B - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/240/180</Box>
          <Box {...frlStyle}>N/A</Box>

          {/* One of up to 3/4" copper or steel pipe - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One of up to 3/4" copper or steel pipe</b>
              <br />
              (max 1.2mm wall thickness), <br /> with or without a 2.5mm² - 2C+E TPS cable
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* One of up to 3/4" copper or steel pipe - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/180</Box>
          <Box {...frlStyle}>-/240/180</Box>
          <Box {...frlStyle}>-/180/120</Box>

          <GridItem {...firstColumnStyles} color={Colors.Primary.c1} rowSpan={3}>
            <b>Service</b>
          </GridItem>
          <GridItem {...firstColumnStyles} color={Colors.Primary.c1} rowSpan={3}>
            <b>Slab Thickness</b>
          </GridItem>
          <GridItem {...firstColumnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>FRL for each lagging type</b>
          </GridItem>

          {/* Sub-headers under FRL */}
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>PE Foam</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>Thermotec E-Flex ST</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>K-Flex ST</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>SuperMax</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>Armaflex FRV nitrile rubber</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>Actrol SuperPair F/R</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>Foilflex / Sekisui foam Foil-faced</b>
          </Box>

          {/* Sub-sub-headers */}
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>NA</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>9-19mm lagging</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>9-19mm lagging</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>9-19mm lagging</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>9-19mm lagging</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>9-19mm lagging</b>
          </Box>
          <Box {...firstColumnStyles} color={Colors.Primary.c1}>
            <b>25mm lagging</b>
          </Box>

          {/* One of up to 1" copper or steel pipe - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One of up to 1" copper or steel pipe</b>
              <br />
              (max 1.2mm wall thickness), with or without a 2.5mm² - 2C+E TPS cable
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* One of up to 1" copper or steel pipe - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* One lagged PN12 PVC Pipe - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One lagged PN12 PVC Pipe</b>
              <br />
              (16-32mm)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* One lagged PN12 PVC Pipe - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/240/240</Box>
          <Box {...frlStyle}>-/180/180</Box>

          <GridItem {...firstColumnStyles}>
            <Text fontWeight="bold" mb="2" color={Colors.Primary.c1}>
              Sealant details
            </Text>
          </GridItem>
          <GridItem {...columnStyles} colSpan={8}>
            <Text>
              In the annular gap between collar opening and cable services or gaps between services not bundled.
              <br />
              When gap ≤5mm: sealant is optional.
              <br />
              When gap ≥ 6mm:
              <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px", color: Colors.Primary.c1 }}>
                Snap Fire Seal FRAS
              </a>{" "}
              to fill gaps to a minimum depth of 10mm depth and finished off flush with the collar opening.
              <br />
              There is no requirement to seal between the conduit and the services passing through the conduit.
            </Text>
          </GridItem>
        </Grid>
      </Box>

      {/* Lagged Pipe Details 40mm Collar Separation Table */}
      <Text {...tableHeadingStyles} mt="8">
        Lagged Pipe Details – 40mm Collar Separation – Active Area to Active Area
      </Text>
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="3fr 1fr repeat(7, 1fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Slab Thickness
          </GridItem>
          <GridItem {...headerStyles} colSpan={7}>
            FRL for each lagging type
          </GridItem>

          {/* Sub-headers under FRL */}
          <Box {...headerStyles}>PE Foam</Box>
          <Box {...headerStyles}>Thermotec E-Flex ST</Box>
          <Box {...headerStyles}>K-Flex ST</Box>
          <Box {...headerStyles}>SuperMax</Box>
          <Box {...headerStyles}>Armaflex FRV nitrile rubber</Box>
          <Box {...headerStyles}>Actrol SuperPair F/R</Box>
          <Box {...headerStyles}>Foilflex / Sekisui foam Foil-faced</Box>

          {/* Sub-sub-headers */}
          <Box {...headerStyles}>9mm lagging</Box>
          <Box {...headerStyles}>9mm lagging</Box>
          <Box {...headerStyles}>9-19mm lagging</Box>
          <Box {...headerStyles}>9-19mm lagging</Box>
          <Box {...headerStyles}>9-19mm lagging</Box>
          <Box {...headerStyles}>9-19mm lagging</Box>
          <Box {...headerStyles}>25mm lagging</Box>

          {/* Paircoil Bundle A - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Paircoil Bundle A</b>
              <br />
              One set of Paircoil (max 3/8" & 3/4") with or without any of the following services:
              <br />
              <ul style={{ listStyleType: "disc", paddingLeft: "20px", textAlign: "left" }}>
                <li>One of up to 25mm PVC pipe</li>
                <li>One of up to 2.5mm² 2C+E TPS power cable</li>
                <li>One of either CAT 5, 5e, 6, 6a or 7 cable</li>
              </ul>
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>-/180/90</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Paircoil Bundle A - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175 mm</Box>
          <Box {...frlStyle}>-/240/90</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          {/* Paircoil Bundle B - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>Paircoil Bundle B </b>
              <br />
              One or two sets of Paircoil (max 3/4" & 3/4") <br />
              with or without any of the following services:
              <br />
              <ul style={{ listStyleType: "disc", paddingLeft: "20px", textAlign: "left" }}>
                <li>One of up to 2.5-mm² 2C+E TPS power cables</li>
                <li>One or two of CAT 5, 5e, 6, 6a or 7 cable</li>
              </ul>
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>NA</Box>
          <Box {...frlStyle}>N/A</Box>

          {/* Paircoil Bundle B - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>N/A</Box>

          {/* One of up to 3/4" copper or steel pipe - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One of up to 3/4" copper or steel pipe</b>
              <br />
              (max 1.2mm wall thickness), <br /> with or without a 2.5mm² - 2C+E TPS cable
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* One of up to 3/4" copper or steel pipe - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/180/120</Box>

          <GridItem {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1} rowSpan={3}>
            Service
          </GridItem>
          <GridItem {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1} rowSpan={3}>
            Slab Thickness
          </GridItem>
          <GridItem {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1} colSpan={7}>
            FRL for each lagging type
          </GridItem>

          {/* Sub-headers under FRL */}
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            PE Foam
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            Thermotec E-Flex ST
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            K-Flex ST
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            SuperMax
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            Armaflex FRV nitrile rubber
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            Actrol SuperPair F/R
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            Foilflex / Sekisui foam Foil-faced
          </Box>

          {/* Sub-sub-headers */}
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            NA
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            9-19mm lagging
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            9-19mm lagging
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            9-19mm lagging
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            9-19mm lagging
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            9-19mm lagging
          </Box>
          <Box {...firstColumnStyles} fontWeight="bold" color={Colors.Primary.c1}>
            25mm lagging
          </Box>

          {/* One of up to 1" copper or steel pipe - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One of up to 1" copper or steel pipe</b>
              <br />
              (max 1.2mm wall thickness), with or without a 2.5mm² - 2C+E TPS cable
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* One of up to 1" copper or steel pipe - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* One lagged PN12 PVC Pipe - Row 1 (≥150mm slab) */}
          <GridItem {...firstColumnStyles} rowSpan={2}>
            <Text>
              <b>One lagged PN12 PVC Pipe</b>
              <br />
              (16-32mm)
            </Text>
          </GridItem>
          <Box {...firstColumnStyles}>≥150mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* One lagged PN12 PVC Pipe - Row 2 (≥175mm slab) */}
          <Box {...firstColumnStyles}>≥175mm</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>
          <Box {...frlStyle}>-/240/120</Box>

          <GridItem {...firstColumnStyles}>
            <Text fontWeight="bold" mb="2" color={Colors.Primary.c1}>
              Sealant details
            </Text>
          </GridItem>
          <GridItem {...columnStyles} colSpan={8}>
            <Text>
              In the annular gap between collar opening and cable services or gaps between services not bundled.
              <br />
              When gap ≤5mm: sealant is optional.
              <br />
              When gap ≥ 6mm:
              <a target="_blank" href="/products/fire-collar/SS-FRAS" style={{ marginLeft: "4px", color: Colors.Primary.c1 }}>
                Snap Fire Seal FRAS
              </a>{" "}
              to fill gaps to a minimum depth of 10mm depth and finished off flush with the collar opening.
              <br />
              There is no requirement to seal between the conduit and the services passing through the conduit.
            </Text>
          </GridItem>
        </Grid>
      </Box>
    </Box>
  )
}
